import type { Route } from "./+types/$locale.about";
import { buildSeoMeta } from "@/components/seo/meta";
import { AboutPage } from "@/features/about/routes/AboutPage";

/**
 * No loader: `<AboutPage>` is fully static content (no data fetching), so no
 * cache seeding is needed. The meta export gives the prerendered HTML SEO
 * tags, then the component renders as before.
 */

export function meta({ params }: Route.MetaArgs) {
    const locale = (params.locale as string) ?? "en";
    return buildSeoMeta({
        title: "About Us — Our Ethos | Stork Rentals",
        description:
            "The story behind Stork Rentals: clean, safe and convenient baby equipment rentals, born from a family's own travel mishap.",
        path: "/about",
        keywords: "about stork rentals, baby equipment rental company, family travel story",
        // TODO Phase 6: hydrate availableLocales from root loader manifest
        locale,
        availableLocales: [{ code: "en" }],
    });
}

export default function AboutRoute() {
    return <AboutPage />;
}
